export const calculateAverage = (arr: unknown[]): number => {
    const numbers = arr.filter((item) => typeof item === 'number') as number[];
    if (numbers.length === 0) {
        return 0;
    }
    const sum = numbers.reduce((acc, curr) => acc + curr, 0);
    const average = sum / numbers.length;
    return average;
};
